import React, { ChangeEvent } from "react";
import UploadIcon from "../../assets/icons/NewUploader";
import { useTranslation } from "react-i18next";
import { showToast } from "../../utils/toastUtils";

interface FileUploadProps {
  onUpload: (file: File) => void;
  canUpload?: boolean;
}

const FileUploadComponent: React.FC<FileUploadProps> = ({
  onUpload,
  canUpload,
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null);

  const handleSelectFile = () => {
    if (canUpload) {
      showToast("Upgrade your subscription to enable this feature.", "info");
      return;
    }
    inputRef.current?.click();
  };
  const { t } = useTranslation("invoices");
  const handleUpload = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      onUpload(e.target.files[0]);
    }
  };

  return (
    <>
      <button
        onClick={handleSelectFile}
        className="flex flex-col items-center justify-center gap-2  px-[13px] py-[8px] rounded-[4px]"
      >
        <UploadIcon />
        <p className="text-gray-800 font-medium">{t("uploadDocument")}</p>
        <p className="text-gray-600 text-sm">JPEG, JPG max 2mb</p>
      </button>
      <input
        className="hidden"
        type="file"
        ref={inputRef}
        accept=".jpg, .png, .jpeg, .pdf"
        onChange={handleUpload}
      />
    </>
  );
};

export default FileUploadComponent;
